module.exports = __webpack_public_path__ + "img/Android5.43306bfc.png";